<script>
import { ScModal, ScModalCard, ScButton } from '@intelipost-js/secure-components';

export default {
  name: 'ScActionModal',
  props: {
    isActive: { type: Boolean, required: true },
    type: { type: String },
    title: { type: String },
    messages: { type: Array },
    cancelText: { type: String, default: 'Voltar' },
    confirmText: { type: String, default: 'Confirmar' },
  },
  methods: {
    onClose() {
      this.$emit('update:isActive', false);
      this.$emit('onCancel');
    },
    onConfirm() {
      this.$emit('update:isActive', false);
      this.$emit('onConfirm');
    },
  },
  components: { ScModal, ScModalCard, ScButton },
};
</script>

<template>
  <sc-modal :active="isActive" @close="onClose" :can-cancel="false">
    <sc-modal-card id="sc-confirmation-modal">
      <template slot="title">
        <div class="title-container">
          <h1 class="modal-tile">{{ title }}</h1>
          <button class="close-button" @click="$emit('update:isActive', false)">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </template>
      <template slot="body">
        <div
          class="info-texts"
          v-if="$slots.default || (messages && messages.length)" >
          <slot name="default">
            <p class="message-array-item" v-for="m in messages">{{ m }}</p>
          </slot>
        </div>
      </template>
      <template slot="footer">
        <button class="button" @click="onClose">{{ cancelText }}</button>
        <button class="button" :class="[`is-${type}`]" @click="onConfirm">{{ confirmText }}</button>
      </template>
    </sc-modal-card>
  </sc-modal>
</template>

<style lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line
#sc-confirmation-modal {
  .modal-card-head {
    background-color: white;
    border-top: none;
  }

  .modal-card-foot {
    background-color: white;
    border-top: none;

    button {
      font-weight: 700;
    }

  }

  .buttons {
    margin-bottom: unset !important;
  }

  .title-container {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    .modal-tile {
      font-size: 20px;
      font-weight: 700;
      color: $primary;
    }

    .close-button {
      all: unset;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .info-texts {
    font-size: 14px;
    font-weight: 400;
    color: #010906;

    .message-array-item:not(:last-child) {
      margin-bottom: 16px;
    }

    strong {
      color: #010906;
    }

  }

  .is-danger {
    background-color: #C8323B;
  }

}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/components/sc-confirmation-modal/ScConfirmationModal.vue?072de69e